module.exports = __webpack_public_path__ + "img/not-sure-smiley.d9931847.svg";